import { createTheme, type Theme } from '@mui/material/styles';
import { buildLightPalette, buildDarkPalette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { softShadows } from './shadows';

export interface BrandingOverride {
  primaryColor?: string;
  secondaryColor?: string;
}

const SPACING_UNIT = 8;

export function createAppTheme(mode: 'light' | 'dark', branding?: BrandingOverride): Theme {
  const palette = mode === 'light'
    ? buildLightPalette(branding?.primaryColor, branding?.secondaryColor)
    : buildDarkPalette(branding?.primaryColor, branding?.secondaryColor);

  return createTheme({
    palette,
    typography,
    spacing: SPACING_UNIT,
    shape: { borderRadius: 8 },
    shadows: softShadows,
    components,
  });
}

export { brandPrimary, brandSecondary, semanticColors } from './palette';
